import React from "react";
import { useTranslation } from "react-i18next";
import { useProjectEdition } from "@planzone/view-models";
import { Props } from "./types";
import styles from "./styles.scss";

function NameForm({ project }: Props) {
  const { t } = useTranslation();
  const { isRequestPending, editProject } = useProjectEdition(project);
  const [name, setName] = React.useState(project.name);

  React.useEffect(() => {
    setName(project.name);
  }, [project.name]);

  return (
    <div className={styles.nameForm}>
      <h3 className={styles.title}>{t("projectDetails.nameTitle")}</h3>
      <input
        className={styles.input}
        placeholder={t("projectDetails.namePlaceholder")}
        value={name}
        onChange={({ target }) => setName(target.value)}
        onBlur={() =>
          !isRequestPending &&
          editProject({ project, nextProject: { ...project, name } })
        }
        onKeyUp={({ key }) =>
          key === "Enter" &&
          editProject({ project, nextProject: { ...project, name } })
        }
      />
    </div>
  );
}

export { NameForm };
